var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zhongyi",attrs:{"id":"zhongyi"}},[_c('div',{staticClass:"con-imgs-box"},[_c('img',{staticClass:"con-img",attrs:{"src":_vm.backUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }